import { axiosObject } from "../config";

export default function downloadPropertyDocument(data: any) {
  return new Promise((resolve, reject) => {
    let uri = "auction/download-document";

    axiosObject
      .post(uri, data)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
